interface PriceProps {
  amount: string | number;
  className?: string;
  /** Render with a leading minus sign (for discounts) */
  negative?: boolean;
}

/**
 * Brand price display: full-size dollars with half-size, underlined cents.
 * e.g. $75.⁰⁰ — sizing is em-based so it scales with the surrounding font size.
 */
export function Price({ amount, className, negative = false }: PriceProps) {
  const num = typeof amount === "string" ? parseFloat(amount) : amount;
  const [dollars, cents] = Math.abs(num).toFixed(2).split(".");
  return (
    <span className={className}>
      {negative && "−"}${dollars}.
      <span className="align-super text-[0.5em] underline decoration-1 underline-offset-2">
        {cents}
      </span>
    </span>
  );
}
